export default "__VITE_ASSET__Bgw1unYc__"